module.exports = __webpack_public_path__ + "logo-vidaldev.png?57c33ed6f9ee03c083a545683f973565";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-vidaldev.png
// module id = 69
// module chunks = 0